import { FaireDirectFirstOrderIncentiveBanner } from "@faire/retailer-visitor-shared/components/Notifications/Components/FaireDirectIncentivesBanner/FaireDirectFirstOrderIncentiveBanner/FaireDirectFirstOrderIncentiveBanner";
import { FirstOrderIncentiveBanner } from "@faire/retailer-visitor-shared/components/Notifications/Components/FirstOrderIncentiveBanner/FirstOrderIncentiveBanner";
import { InsiderAutoEnrollBanner } from "@faire/retailer-visitor-shared/components/Notifications/Components/InsiderAutoEnrollBanner/InsiderAutoEnrollBanner";
import { OpenWithFaireEligibleToApplyBanner } from "@faire/retailer-visitor-shared/components/Notifications/OpenWithFaireEligibleToApplyBanner";
import { PromoBannerType } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/bannerOrder";
import { useFirstOrderIncentiveStore } from "@faire/retailer-visitor-shared/hooks/firstOrderIncentive/useFirstOrderIncentiveStore";
import { usePromoBanners } from "@faire/retailer-visitor-shared/stores/ui/usePromoBanners";
import React, { useMemo } from "react";

export const useFaireDirectFirstOrderIncentiveBanners = () => {
  const { isFirstOrderForFaireDirectIncentive } = useFirstOrderIncentiveStore();
  const {
    showInsiderAutoEnrollBanner,
    showOpenWithFaireEligibleToApplyBanner,
  } = usePromoBanners();

  return useMemo(
    () => ({
      ...(isFirstOrderForFaireDirectIncentive
        ? {
            [PromoBannerType.FIRST_ORDER_INCENTIVE]: (
              <FirstOrderIncentiveBanner />
            ),
          }
        : {}),
      [PromoBannerType.FAIRE_DIRECT_FIRST_ORDER_INCENTIVE]: (
        <FaireDirectFirstOrderIncentiveBanner />
      ),
      ...(showInsiderAutoEnrollBanner
        ? { [PromoBannerType.INSIDER_AUTO_ENROLL]: <InsiderAutoEnrollBanner /> }
        : {}),
      ...(showOpenWithFaireEligibleToApplyBanner
        ? {
            [PromoBannerType.OPEN_WITH_FAIRE]: (
              <OpenWithFaireEligibleToApplyBanner />
            ),
          }
        : {}),
    }),
    [
      showInsiderAutoEnrollBanner,
      showOpenWithFaireEligibleToApplyBanner,
      isFirstOrderForFaireDirectIncentive,
    ]
  );
};
